import {
    findReport,
    resourceHeroImage,
    resourcePath,
} from '@/components/www/resources/shared/resources'

/** Resources mega items — shared between the desktop panel and the mobile accordion. */
export interface ResourceMenuItem {
    id: string
    label: string
    description: string
    to: string
}

export interface ResourceMenuColumn {
    id: string
    title: string
    items: ResourceMenuItem[]
}

export const resourceMenuColumns: ResourceMenuColumn[] = [
    {
        id: 'use',
        title: 'Use',
        items: [
            {
                id: 'help',
                label: 'Help Center',
                description: 'Listing, sync, and submissions',
                to: '/help',
            },
            {
                id: 'tools',
                label: 'Tools',
                description: 'Check a product before you submit',
                to: '/tools',
            },
            {
                id: 'api-docs',
                label: 'API Docs',
                description: 'Catalogs, listings, and orders',
                to: '/api-docs',
            },
            {
                id: 'mcp',
                label: 'MCP Server',
                description: 'Use Osello from Claude or ChatGPT',
                to: '/mcp',
            },
        ],
    },
    {
        id: 'read',
        title: 'Read',
        items: [
            {
                id: 'reports',
                label: 'Reports',
                description: 'Original research on marketplace selling',
                to: '/reports',
            },
            {
                id: 'blog',
                label: 'Blog',
                description: 'Notes from the team',
                to: '/blog',
            },
            {
                id: 'announcements',
                label: 'Announcements',
                description: 'Product and marketplace news',
                to: '/announcements',
            },
            {
                id: 'changelog',
                label: 'Changelog',
                description: 'What\'s new in Osello',
                to: '/change-logs',
            },
        ],
    },
]

export const resourceMenuMobileItems: ResourceMenuItem[] = resourceMenuColumns.flatMap(column => column.items)

const featuredReport = findReport('marketplace-fashion-brand-loyalty-report')

export const featuredResource = {
    eyebrow: 'Report',
    title: featuredReport.title,
    description: '211,523 orders. A 12% repeat rate no brand dashboard can see.',
    to: resourcePath(featuredReport),
    image: resourceHeroImage(featuredReport),
    cta: 'Read the report',
} as const
